export const SHARED_TAGS = {
  USERS: 'AllUsers',
  CAMPAIGN_CATEGORY_INFO: 'CampaignCategoryInfo'
} as const
